/* Maison Mayhem — theme.js
   Calm, minimal interactions. No urgency patterns, no celebratory animation. */
(function () {
  'use strict';

  var root = document.documentElement;
  /* 18 Oct 2026 (founder: "my incognito is showing checkout in SGD"): bag calls now go through the market root (/en-my/ for Malaysia, / for Singapore). Before, a new Malaysian visitor adding to bag got a Singapore cart in S$. */
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Mobile nav ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var menuClose = document.querySelector('[data-menu-close]');
  function openMenu() { if (mobileNav) { mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeMenu() { if (mobileNav) { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; } }
  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (mobileNav) mobileNav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var drawerBody = document.querySelector('[data-cart-body]');
  var drawerFoot = document.querySelector('[data-cart-foot]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openCart() { if (drawer) { drawer.classList.add('is-open'); overlay.classList.add('is-open'); } }
  function closeCart() { if (drawer) { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); } }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); renderCart(); }); });
  document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMenu(); } });

  /* 18 Oct 2026 (founder: "the your bag is still showing subtotal in SGD terms, can you differentiate?"):
     the bag shows the currency the shopper pays in, RM on /en-my/ (Malaysia), S$ in Singapore. */
  var moneySymbol = 'S$';
  /* 20 Oct 2026: Hong Kong shows HK$. 21 Oct 2026: Australia shows A$. */
  function setMoneySymbol(code) { moneySymbol = code === 'MYR' ? 'RM' : (code === 'HKD' ? 'HK$' : (code === 'AUD' ? 'A$' : (code && code !== 'SGD' ? code + ' ' : 'S$'))); }
  if (window.Shopify && Shopify.currency && Shopify.currency.active) setMoneySymbol(Shopify.currency.active);
  function formatMoney(cents) {
    var v = cents / 100;
    return moneySymbol + v.toLocaleString('en-SG', { minimumFractionDigits: v % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
  }

  function changeLine(key, qty) {
    fetch(R + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { renderCart(); });
  }

  function renderCart() {
    if (!drawerBody) return;
    fetch(R + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.currency) setMoneySymbol(cart.currency);
        cartCountEls.forEach(function (el) { el.textContent = cart.item_count; });
        if (cart.item_count === 0) {
          drawerBody.innerHTML = '<p class="cart-empty">Your bag is empty. The floor can wait.</p>';
          if (drawerFoot) drawerFoot.innerHTML = '';
          return;
        }
        var html = '';
        cart.items.forEach(function (item) {
          var img = item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '">' : '';
          html += '<div class="cart-line">' +
            '<div class="cart-line__media">' + img + '</div>' +
            '<div><div class="cart-line__name">' + item.product_title + '</div>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__meta">' + item.variant_title + '</div>' : '') +
            '<div style="display:flex;align-items:center;gap:10px;margin-top:6px;">' +
              '<button type="button" data-dec="' + item.key + '" style="width:26px;height:26px;border:1px solid #948677;background:none;cursor:pointer;">–</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-inc="' + item.key + '" style="width:26px;height:26px;border:1px solid #948677;background:none;cursor:pointer;">+</button>' +
              '<button type="button" data-remove="' + item.key + '" style="margin-left:8px;border:none;background:none;text-decoration:underline;color:#948677;cursor:pointer;">Remove</button>' +
            '</div></div>' +
            '<div class="body-s">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>';
        });
        drawerBody.innerHTML = html;
        drawerBody.querySelectorAll('[data-inc]').forEach(function (b) { b.addEventListener('click', function () { var it = cart.items.filter(function (i) { return i.key === b.getAttribute('data-inc'); })[0]; changeLine(b.getAttribute('data-inc'), (it ? it.quantity : 1) + 1); }); });
        drawerBody.querySelectorAll('[data-dec]').forEach(function (b) { b.addEventListener('click', function () { var it = cart.items.filter(function (i) { return i.key === b.getAttribute('data-dec'); })[0]; changeLine(b.getAttribute('data-dec'), Math.max(0, (it ? it.quantity : 1) - 1)); }); });
        drawerBody.querySelectorAll('[data-remove]').forEach(function (b) { b.addEventListener('click', function () { changeLine(b.getAttribute('data-remove'), 0); }); });
        if (drawerFoot) {
          /* Plain checkout link. The old link forced the expired FIRST50 code onto every checkout. */
          var note = drawerFoot.getAttribute('data-note') || 'Shipping calculated at checkout.';
          drawerFoot.innerHTML =
            '<div class="cart-subtotal"><span class="uppercase-spaced">Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
            '<a class="btn" href="' + R + 'checkout">Checkout</a>' +
            '<p class="form-note">' + note + '</p>';
        }
      });
  }

  /* AJAX add-to-bag */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
      fetch(R + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: (function () {
          var item = { id: form.querySelector('[name="id"]').value, quantity: 1 };
          var sp = form.querySelector('[name="selling_plan"]');
          if (sp && sp.value) item.selling_plan = sp.value;
          return JSON.stringify({ items: [item] });
        })()
      }).then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && (data.status || data.description)) {
          console.warn('Add to cart failed:', data);
          if (btn) { btn.disabled = false; btn.textContent = 'Please try again'; setTimeout(function () { btn.textContent = btn.dataset.label; }, 2500); }
        } else { openCart(); renderCart(); if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } }
      })
      .catch(function (err) { console.warn('Add to cart network error:', err); if (btn) { btn.disabled = false; btn.textContent = 'Please try again'; setTimeout(function () { btn.textContent = btn.dataset.label; }, 2500); } });
    });
  });

  /* Initial cart count */
  if (cartCountEls.length) {
    fetch(R + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartCountEls.forEach(function (el) { el.textContent = cart.item_count; }); });
  }

  /* ---------- Variant selector ---------- */
  document.querySelectorAll('[data-variant-selector]').forEach(function (group) {
    var hidden = document.querySelector('[data-variant-id]');
    group.querySelectorAll('.variant-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        group.querySelectorAll('.variant-pill').forEach(function (p) { p.classList.remove('is-selected'); p.setAttribute('aria-pressed', 'false'); });
        pill.classList.add('is-selected'); pill.setAttribute('aria-pressed', 'true');
        if (hidden && pill.dataset.variantId) hidden.value = pill.dataset.variantId;
        var priceEl = document.querySelector('[data-price]');
        if (priceEl && pill.dataset.price) priceEl.textContent = pill.dataset.price;
      });
    });
  });

  /* ---------- PDP gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main]');
    gal.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main && thumb.dataset.full) main.src = thumb.dataset.full;
        gal.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- FAQ accordion (single-open) ---------- */
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    acc.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.accordion__item');
        var panel = item.querySelector('.accordion__panel');
        var isOpen = item.classList.contains('is-open');
        acc.querySelectorAll('.accordion__item').forEach(function (i) {
          i.classList.remove('is-open');
          i.querySelector('.accordion__panel').style.maxHeight = null;
          i.querySelector('[data-accordion-trigger]').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  /* ---------- Sticky mobile CTA (appears after hero 80% past viewport) ---------- */
  var stickyCta = document.querySelector('[data-sticky-cta]');
  var heroAnchor = document.querySelector('[data-sticky-anchor]');
  if (stickyCta && heroAnchor && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 0.2) stickyCta.classList.add('is-visible');
        else stickyCta.classList.remove('is-visible');
      });
    }, { threshold: [0.2] });
    obs.observe(heroAnchor);
  }

  /* ---------- Lifestyle in-view opacity (subtle) ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var lifeObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.style.opacity = '1'; lifeObs.unobserve(e.target); } });
    }, { threshold: 0.1 });
    document.querySelectorAll('[data-fade-in]').forEach(function (el) {
      el.style.opacity = '0'; el.style.transition = 'opacity var(--d-editorial, 800ms) var(--ease)';
      lifeObs.observe(el);
    });
  }
})();